import React from 'react';
import type { PaginationMeta } from './types';
import classes from './jobCosting.module.css';

interface Props {
  meta: PaginationMeta;
  onPageChange: (page: number) => void;
}

/** Server-side pagination control driven by the Spatie paginator meta. */
function Pagination({ meta, onPageChange }: Props) {
  if (meta.lastPage <= 1) return null;

  const from = (meta.currentPage - 1) * meta.perPage + 1;
  const to = Math.min(meta.currentPage * meta.perPage, meta.total);

  return (
    <div className={classes.pagination}>
      <span>
        Showing
{' '}
{from}
–
{to}
{' '}
of
{' '}
{meta.total}
      </span>
      <div className={classes.pageButtons}>
        <button
          type="button"
          className={classes.pageButton}
          onClick={() => onPageChange(meta.currentPage - 1)}
          disabled={meta.currentPage <= 1}
        >
          &laquo; Prev
        </button>
        <span className={classes.pageButton}>
          {meta.currentPage}
{' '}
/
{meta.lastPage}
        </span>
        <button
          type="button"
          className={classes.pageButton}
          onClick={() => onPageChange(meta.currentPage + 1)}
          disabled={meta.currentPage >= meta.lastPage}
        >
          Next &raquo;
        </button>
      </div>
    </div>
  );
}

export { Pagination };
